import { PlaceActionType } from './place-action-type';

export interface SetPlacePageIdAction {
  placeKey: string;
  pageId: string;
  type: PlaceActionType.SetPlacePageId;
}

export const setPlacePageId = (
  placeKey: string,
  pageId: string,
): SetPlacePageIdAction => ({
  placeKey,
  pageId,
  type: PlaceActionType.SetPlacePageId,
});
